import React from 'react';
import { RotateCw } from 'lucide-react';
import { OnboardingStatusBanner } from './OnboardingStatusBanner';
import { Organization } from '../../../../types/organization.types';
import { isCrmConnectedViaRollout } from '../../../../utils/rollout';

interface RolloutSyncStatusBannerProps {
  organization?: Organization | null;
}

/**
 * Header banner that shows sync progress when FUB initial sync is processing.
 * Only displays when status is 'processing'.
 */
export const RolloutSyncStatusBanner: React.FC<RolloutSyncStatusBannerProps> = ({
  organization,
}) => {
  const isFubConnected = isCrmConnectedViaRollout(
    { crmConnections: organization?.crmConnections, rollout: organization?.rollout },
    'follow-up-boss'
  );
  const syncStatus = organization?.last_initial_sync;

  // Only show when FUB is connected and sync is processing
  if (!isFubConnected || !syncStatus || syncStatus.status !== 'processing') {
    return null;
  }

  const progressPercentage = syncStatus.progress?.percentage_complete ?? 0;
  const contactsProcessed = syncStatus.progress?.contacts_processed ?? 0;
  const totalContacts = syncStatus.progress?.total_contacts_in_crm ?? 0;

  return (
    <OnboardingStatusBanner
      icon={RotateCw}
      title={`Syncing Contacts from Follow Up Boss... ${progressPercentage.toFixed(0)}%`}
      variant="orange"
      iconClassName="animate-spin"
      defaultMinimized={false}
    >
      <p className="text-xs mt-1">
        <strong>{contactsProcessed.toLocaleString()}</strong> contacts processed of <strong>{totalContacts.toLocaleString()}</strong> total
      </p>
    </OnboardingStatusBanner>
  );
};
